module.exports = __webpack_public_path__ + "8f8a6d42e8194ec8ccaccb4ce467bbfc.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/credit-score-graph.svg
// module id = 620
// module chunks = 0